import { createContext, useContext } from 'react';

interface IDwebSavedPaymentsContext {
  showSavedPayments: VoidFunction;
  canShowSavedPayments: boolean;
}

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

const dwebSavedPaymentsContext = createContext<IDwebSavedPaymentsContext>({
  showSavedPayments: EMPTY_FUNC,
  canShowSavedPayments: false,
});

export const useDwebSavedPaymentsContext = () => useContext(dwebSavedPaymentsContext);

export default dwebSavedPaymentsContext;
